import { Component, OnDestroy } from "@angular/core";
import { HeaderService } from "src/app/components/header/header.service";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { MatDialog } from "@angular/material/dialog";
import { WarehousesTooltipComponent } from "../warehouses-tooltip/warehouses-tooltip.component";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-number-and-trend-cell-renderer",
  templateUrl: "./number-and-trend-cell-renderer.component.html",
  styleUrls: ["./number-and-trend-cell-renderer.component.scss"],
})
export class NumberAndTrendCellRendererComponent implements OnDestroy {
  params;
  amount: number;
  trend: string;
  props;
  Velocity90_1yr: any;
  PctChange1Yr: any;
  PctChange2Yr:any
  isApplied:boolean=false;
  isShowYearlyTrend: any;
  showSeasonal:boolean=false;
  PurchaseDayVel1yr:any;
  PurchaseDayVel2yr:any;
  Velocity90Days:any;
  Velocity90Days2yr:any;
  isPreviousFeeUp: boolean;
  isNewFeeUp: boolean;
  isPurchasingVelocity:boolean = false;
  private destroy$ = new Subject<void>();
  constructor(private shipyardService:ShipyardService,
   private headerService: HeaderService,
   private dialog:MatDialog) {
    this.headerService.isShowYearlyTrends$.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      this.isShowYearlyTrend = res;
    })
  }

  agInit(params: any): void {
    this.params = params;
    this.props = this.params["props"];
    this.PurchaseDayVel1yr = this.params.data[this.props["PurchaseDayVel1yr"]];
    this.PurchaseDayVel2yr = this.params.data[this.props["PurchaseDayVel2yr"]];
    this.Velocity90_1yr = this.params.data[this.props["Velocity90_1yr"]];
    this.Velocity90Days = this.params.data[this.props["Velocity90days"]];
    this.Velocity90Days2yr = this.params.data[this.props["Velocity90days2yr"]];
    this.isPurchasingVelocity = this.props["isPurchasingVelocity"];
    let pctChange1Yr  = this.params.data[this.props["PctChange1Yr"]];
    this.PctChange2Yr = this.params.data[this.props["PctChange2Yr"]];
    this.showSeasonal= this.props["showSeasonal"];
    this.Velocity90_1yr= this.Velocity90_1yr ? this.Velocity90_1yr.toFixed() : 0;
    pctChange1Yr = pctChange1Yr ? pctChange1Yr.toFixed() : 0;
    this.PctChange1Yr = pctChange1Yr > 0 ? `+${pctChange1Yr}`: pctChange1Yr;
    if (this.props["trendProp"]) {
      if (
        this.params.data[this.props["trendProp"].high] >
        this.params.data[this.props["trendProp"].low]
      ) {
        this.trend = "up";
      } else if (
        this.params.data[this.props["trendProp"].high] <
        this.params.data[this.props["trendProp"].low]
      ) {
        this.trend = "down";
      }
    }

    if (this.props["trendBit"]) {
      const trend = this.params.data[this.props["trendBit"]];
      if (trend === 1) {
        this.trend = 'up';
      } else if (trend === -1) {
        this.trend = "down";
      }
    }
    if (this.props["dollarProp"]) {
      this.props["numberProp"] === 'PreviousEstimatedFeeTotal' && params.data?.PreviousEstimatedFeeTotal > params.data?.EstimatedFeeTotal ? this.trend = "up" : 
      this.props["numberProp"] === 'EstimatedFeeTotal' && params.data?.EstimatedFeeTotal > params.data?.PreviousEstimatedFeeTotal ? this.trend = "up" :
      params.data?.PreviousEstimatedFeeTotal === params.data?.EstimatedFeeTotal ? this.trend = '' : this.trend = "down"
    }
  }

  addAmountToShipment(amount) {
    amount=Number(amount);
    let appliedAmount=0,enforceValue=0;
    if(amount && this.showSeasonal){
      this.isApplied=!this.isApplied; 
      if(this.params.data.CaseQty > 0 ){
        const value=((amount + (this.params.data.Restock )) / this.params.data.CaseQty).toFixed() 
        appliedAmount= (Number(value) * this.params.data.CaseQty);
        enforceValue=   (Number(value) * this.params.data.CaseQty) - (amount + (this.params.data.Restock))
      } else{
        appliedAmount=this.params.data.Restock + amount;
      }      
      this.shipyardService.seasonalValueChanged.next({amount:!this.isApplied ? null : appliedAmount, appliedSeasonalVelocity : amount,node:this.params.node,enforceValue:enforceValue});  
    }
  }

  openExpandDialog(event: MouseEvent) {
    event.stopPropagation();
    this.dialog.open(WarehousesTooltipComponent, {
      position: this.getDialogPosition(event),
      data: { 
        Velocity90_1yr: this.Velocity90Days,
        Velocity90Days2yr:this.Velocity90Days2yr,
        PurchaseDayVel1yr:this.PurchaseDayVel1yr,
        PurchaseDayVel2yr:this.PurchaseDayVel2yr,
        PctChange1Yr:this.PctChange1Yr,
        PctChange2Yr:this.PctChange2Yr,
        IsPurchasedVelocity:true
       },
      backdropClass: ["cdk-overlay-transparent-backdrop", "arrow-backdrop"],
    })
  }
  getDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      left: targetPosision.right - 52 + "px",
      top: targetPosision.top + 20 + "px",
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
